import Cookies from "js-cookie";
import { Mixpanel } from "./Mixpanel";

const cookieDomain = process.env.REACT_APP_COOKIE_HOST;
const removeCookieOptions = { path: "/", domain: cookieDomain };

const clientHubAccessTokenCookieName = "clientHubAccessToken";
const clientHubRefreshTokenCookieName = "clientHubRefreshToken";

function getCookieNameCount(cookieName) {
    if (typeof document === "undefined") {
        return 0;
    }
    return document.cookie.split(";").filter(cookie => {
        return cookie.trim().startsWith(cookieName + "=");
    }).length;
}

function getReadableCookieCount() {
    if (typeof document === "undefined" || document.cookie.trim().length === 0) {
        return 0;
    }
    return document.cookie.split(";").filter(cookie => {
        return cookie.trim().length > 0;
    }).length;
}

class TokenService {

    isAuthenticated() {
        var token = Cookies.get(clientHubRefreshTokenCookieName);
        if (token) {
            return true;
        }
        return false;
    }

    logoutClientHub(caller, logoutContext) {
        const context = logoutContext || {};
        const accessCookiePresentBeforeLogout = Boolean(Cookies.get(clientHubAccessTokenCookieName));
        const refreshCookiePresentBeforeLogout = Boolean(Cookies.get(clientHubRefreshTokenCookieName));
        const accessCookieNameCountBeforeLogout = getCookieNameCount(clientHubAccessTokenCookieName);
        const refreshCookieNameCountBeforeLogout = getCookieNameCount(clientHubRefreshTokenCookieName);
        const readableCookieCountBeforeLogout = getReadableCookieCount();

        Cookies.remove(clientHubAccessTokenCookieName, removeCookieOptions);
        Cookies.remove(clientHubRefreshTokenCookieName, removeCookieOptions);

        if (typeof window !== "undefined" && typeof document !== "undefined") {
            try {
                Mixpanel.track("UI ID - Client Hub logout", {
                    caller: caller || "unknown",
                    accountLogoutOutcome: context.accountLogoutOutcome || "unknown",
                    idLogoutStartedAtEpochMs: context.idLogoutStartedAtEpochMs || null,
                    millisecondsSinceIdLogoutStarted: context.idLogoutStartedAtEpochMs
                        ? Date.now() - context.idLogoutStartedAtEpochMs
                        : null,
                    clientNowEpochSeconds: Math.floor(Date.now() / 1000),
                    clientNowIso: new Date().toISOString(),
                    accessCookiePresentBeforeLogout: accessCookiePresentBeforeLogout,
                    refreshCookiePresentBeforeLogout: refreshCookiePresentBeforeLogout,
                    accessCookieNameCountBeforeLogout: accessCookieNameCountBeforeLogout,
                    refreshCookieNameCountBeforeLogout: refreshCookieNameCountBeforeLogout,
                    readableCookieCountBeforeLogout: readableCookieCountBeforeLogout,
                    accessCookiePresentAfterLogout: Boolean(Cookies.get(clientHubAccessTokenCookieName)),
                    refreshCookiePresentAfterLogout: Boolean(Cookies.get(clientHubRefreshTokenCookieName)),
                    accessCookieNameCountAfterLogout: getCookieNameCount(clientHubAccessTokenCookieName),
                    refreshCookieNameCountAfterLogout: getCookieNameCount(clientHubRefreshTokenCookieName),
                    readableCookieCountAfterLogout: getReadableCookieCount(),
                    configuredCookieDomain: cookieDomain || null,
                    pageHostname: window.location.hostname,
                    pageProtocol: window.location.protocol,
                    browserCookiesEnabled: navigator.cookieEnabled,
                    documentVisibilityState: document.visibilityState,
                });
            } catch (error) {
                // Diagnostics must never interfere with logout.
            }
        }
    }
}

export default new TokenService();
